// src/pages/Moderation/UsersViolationsPage/ui/UsersViolationsTable/UsersViolationsHeader.tsx
import React from 'react';

export const UsersViolationsHeader: React.FC = () => {
  return (
    <div className="uv-table__header">
      <div className="uv-table__cell">User</div>
      <div className="uv-table__cell">Email</div>
      <div className="uv-table__cell">ID</div>
      <div className="uv-table__cell">Restrictions</div>
      <div className="uv-table__cell">Created / Last login</div>
      <div className="uv-table__cell">Action</div>
    </div>
  );
};
